export const componentMappers = {
	option: 'InputSelect',
	textbox: 'InputText',
	phoneCert: 'InputPhoneCert',
	checkbox: 'InputCheckbox',
};

export const serviceMappers = {
	VDF: {
		bgImage: require('@/assets/img/vdf/vdf_bg.jpeg'),
		logoPath: require('@/assets/img/vdf/vdf_logo.png'),
		primary: '#A71596',
		infoColor: '#fff',
		mainBtn: {
			bg: 'transparent',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#000',
			border: ' 1px solid #fff',
		},
		baseBtn: {
			active: '#A71596',
		},
		snsIcon: {
			bg: '#fff',
			bgHover: '#A71596',
			color: '#000',
			colorHover: '#fff',
		},
		snsURL: {
			homepage: 'http://www.vector-dj-festival.com/',
			instagram: 'https://www.instagram.com/vector.festival/',
			facebook: 'https://www.facebook.com/vectordjfestival',
		},
		caption: {
			child: '#a5a4a5',
			old: '#6937a1',
		},
	},
	SPARTAN: {
		bgImage: require('@/assets/img/spartan/spartan_bg.jpg'),
		bgImageMobile: require('@/assets/img/spartan/spartan_bg_mobile.jpg'),
		logoPath: require('@/assets/img/spartan/spartan_logo.png'),
		primary: '#cf102d',
		infoColor: '#000',
		mainBtn: {
			bg: '#000',
			bgHover: '#cf102d',
			color: '#cf102d',
			colorHover: '#fff',
			border: '1px solid #cf102d',
		},
		baseBtn: {
			active: '#cf102d',
		},
		snsIcon: {
			bg: '#000',
			bgHover: '#cf102d',
			color: '#fff',
			colorHover: '#fff',
		},
		snsURL: {
			homepage: 'http://spartanracekorea.com/',
			instagram: 'https://www.instagram.com/spartanracekorea/',
			facebook: 'https://www.facebook.com/spartanracekorea/',
		},
		caption: {
			child: '#84bd00',
			old: '#5c068c',
		},
	},
	S2O: {
		bgImage: require('@/assets/img/s2o/s2o_bg.jpg'),
		bgImageMobile: require('@/assets/img/s2o/s2o_bg_mobile.jpg'),
		logoPath: require('@/assets/img/s2o/s2o_logo.png'),
		sponsorImage: require('@/assets/img/s2o/s2o_sponsor.png'),
		primary: '#2d7dc2',
		infoColor: '#fff',
		mainBtn: {
			bg: 'linear-gradient(to right, #62d1d4 9%, #2d7dc2 89%)',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#2d7dc2',
			border: 0,
		},
		baseBtn: {
			active: 'linear-gradient(to right, #62d1d4 9%, #2d7dc2 89%)',
		},
		snsIcon: {
			bg: 'url(#s2o)',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#2d7dc2',
		},
		snsURL: {
			homepage: 'http://www.s2okoreafest.com/home',
			instagram: 'https://www.instagram.com/s2ofestival/',
			facebook: 'https://www.facebook.com/S2OKOREA/',
		},
		caption: {
			child: '#62d1d4',
			old: '#8500cf',
		},
	},
	'CJ-HOL': {
		bg: {
			position: 'fixed',
			imagePath: require('@/assets/img/cj-hol/cj-hol_bg.png'),
			imageMobilePath: require('@/assets/img/cj-hol/cj-hol_bg_mobile.png'),
			backgroundPosition: 'center bottom',
		},
		logoPath: require('@/assets/img/cj-hol/cj-hol_logo.png'),
		wizdomeLogo: {
			path: require('@/assets/img/cj-hol/cj-hol_wizdome_logo.png'),
			position: 'bottom',
		},
		primary: '#006ecd',
		infoColor: '#000',
		text: {
			mainInfo: '#000',
			sideMenuInfo: '#bb9c6b',
		},
		bookBtn: {
			bg: '#006ecd',
			color: '#fff',
			border: 0,
		},
		etcBtn: {
			bg: '#ff9700',
			color: '#fff',
			border: 0,
		},
		mybookBtn: {
			bg: '#ef151e',
			color: '#fff',
			border: 0,
		},
		cancelBtn: {
			bg: '#97999b',
			color: '#fff',
			border: 0,
		},
		faqBtn: {
			bg: '#fff',
			color: '#666666',
			border: '1px solid #97999b',
		},
		baseBtn: {
			active: '#006ecd',
		},
	},
	RAPBEAT: {
		bgImage: require('@/assets/img/rapbeat/rapbeat_bg.jpg'),
		bgImageMobile: require('@/assets/img/rapbeat/rapbeat_bg_mobile.jpg'),
		logoPath: require('@/assets/img/rapbeat/rapbeat_logo.png'),
		sponsorImage: require('@/assets/img/rapbeat/rapbeat_sponsor.png'),
		wizdomeLogo: {
			path: require('@/assets/img/rapbeat/rapbeat_wizdome_logo.png'),
			position: 'top',
		},
		primary: '#dc558c',
		infoColor: '#dc558c',
		text: {
			mainInfo: '#000',
			sideMenuInfo: '#000',
		},
		mainBtn: {
			bg: '#dc558c',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#dc558c',
		},
		baseBtn: {
			active: '#dc558c',
		},
		snsIcon: {
			bg: '#dc558c',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#dc558c',
		},
		snsURL: {
			instagram: 'https://www.instagram.com/rapbeatfestival/',
			facebook: 'https://www.facebook.com/RAPBEATFESTIVAL/',
			twitter:
				'https://twitter.com/RAPBEATFESTIVAL?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
			kakaotalkChannel: 'https://pf.kakao.com/_LvhQxd',
			tiktok: 'https://www.tiktok.com/@rapbeatfestival',
		},
	},
	VDF2: {
		bg: {
			position: 'fixed',
			imagePath: require('@/assets/img/vdf2/vdf_bg.jpg'),
			backgroundPosition: 'center bottom',
		},
		logo: {
			imagePath: require('@/assets/img/vdf2/vdf_logo.png'),
			position: 'top',
		},
		wizdomeLogo: {
			path: require('@/assets/img/vdf2/vdf_wizdome_logo.png'),
			position: 'bottom',
		},
		primary: '#8618c7',
		infoColor: '#fff',
		text: {
			mainInfo: '#fff',
			sideMenuInfo: '#fff',
		},
		mainBtn: {
			bg: '#8618c7',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#8618c7',
		},
		baseBtn: {
			active: '#8618c7',
		},
		snsIcon: {
			bg: '#8618c7',
			bgHover: '#fff',
			color: '#fff',
			colorHover: '#8618c7',
		},
		snsURL: {
			homepage: 'http://www.vector-dj-festival.com/',
			instagram: 'https://www.instagram.com/vector.festival/',
			facebook: 'https://www.facebook.com/vectordjfestival',
		},
	},
};
